import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "styled-components";
var _FutureLiveCardOverla, _Calendar, _Clock;
var _excluded = ["className", "style", "css", "data-testid", "data-cy", "me", "disableRedirections", "onGoToLiveDetail", "onSubscribeToLive", "subscriptionIsLoading", "openLiveDetailInNewTab", "source", "sourceDetail"];
import cn from "classnames";
import { createUrlWithSourceQueryParams } from "@crehana/analytics";
import { Calendar, Clock } from "@crehana/icons/outline";
import { Clamp, InverseButton, LazyImage, PrimaryButton } from "@crehana/ui";
import { date } from "@crehana/utils";
import { LiveTargetEnum } from "../../../__generated__/graphql-schema";
import PremiumExclusiveTag from "../../Tags/PremiumExclusiveTag";
import useFutureLiveCardTranslation from "./hooks/useFutureLiveCardTranslation";
import useLiveState from "./hooks/useLiveState";
import { FutureLiveCardContainer, FutureLiveCardOverlay } from "./FutureLiveCard.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FutureLiveCard = function FutureLiveCard(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'w-full' : _ref$className,
    style = _ref.style,
    css = _ref.css,
    dataTestId = _ref['data-testid'],
    dataCy = _ref['data-cy'],
    me = _ref.me,
    disableRedirections = _ref.disableRedirections,
    onGoToLiveDetail = _ref.onGoToLiveDetail,
    onSubscribeToLive = _ref.onSubscribeToLive,
    subscriptionIsLoading = _ref.subscriptionIsLoading,
    openLiveDetailInNewTab = _ref.openLiveDetailInNewTab,
    source = _ref.source,
    sourceDetail = _ref.sourceDetail,
    live = _objectWithoutProperties(_ref, _excluded);
  var title = live.title,
    coverCard = live.coverCard,
    coverCardPlaceholder = live.coverCardPlaceholder,
    liveDetailUrl = live.liveDetailUrl,
    liveCategory = live.liveCategory,
    targetEnum = live.targetEnum,
    isLive = live.isLive,
    startLive = live.startLive,
    dueLive = live.dueLive,
    isSubscribed = live.isSubscribed;
  var liveDate = startLive ? {
    day: date.format(startLive, 'DD [de] MMMM'),
    time: date.format(startLive, 'HH:mm[ hrs.]')
  } : undefined;
  var isPremiumLive = targetEnum === LiveTargetEnum.TARGET_PREMIUM;
  var liveUrlWithSource = liveDetailUrl ? createUrlWithSourceQueryParams({
    url: liveDetailUrl,
    source: source,
    sourceDetail: sourceDetail
  }) : undefined;
  var _useFutureLiveCardTra = useFutureLiveCardTranslation(),
    t = _useFutureLiveCardTra.t;
  var _useLiveState = useLiveState({
      isLive: isLive,
      startLive: startLive,
      dueLive: dueLive
    }),
    liveState = _useLiveState.liveState;
  var goToLiveDetail = function goToLiveDetail() {
    if (onGoToLiveDetail) {
      onGoToLiveDetail(live);
    }
    if (!disableRedirections && liveUrlWithSource) {
      if (openLiveDetailInNewTab) {
        window.open(liveUrlWithSource);
      } else {
        window.location.href = liveUrlWithSource;
      }
    }
  };
  var renderButtons = function renderButtons() {
    var canGoToLiveDetail = !disableRedirections && liveUrlWithSource || goToLiveDetail;
    var canSubscribeToLive = onSubscribeToLive && !isSubscribed && ((me === null || me === void 0 ? void 0 : me.isPremium) || !isPremiumLive);
    if (!canGoToLiveDetail && !canSubscribeToLive && !isSubscribed) {
      return null;
    }
    var goToLiveDetailButtonProps = onGoToLiveDetail ? {
      onClick: goToLiveDetail
    } : {
      href: liveUrlWithSource,
      target: openLiveDetailInNewTab ? '_blank' : undefined,
      rel: openLiveDetailInNewTab ? 'noopener noreferrer' : undefined
    };
    if (liveState === 'future') {
      return /*#__PURE__*/_jsxs("footer", {
        className: "flex flex-col-reverse mt-24 sm:flex-row sm:items-center",
        children: [canGoToLiveDetail && /*#__PURE__*/_jsx(InverseButton, _objectSpread({
          className: cn('w-full px-0', {
            'mt-12 sm:w-1/2 sm:mt-0 sm:mr-20 md:mr-8 lg:mr-20': canSubscribeToLive || isSubscribed
          }),
          label: t('SEE_DETAILS'),
          isWhite: true,
          isDark: true
        }, goToLiveDetailButtonProps)), (canSubscribeToLive || isSubscribed) && /*#__PURE__*/_jsx(PrimaryButton, {
          className: cn('w-full px-0', {
            'sm:w-1/2': canGoToLiveDetail
          }),
          label: t(isSubscribed ? 'ALREADY_SUBSCRIBED' : 'SUBSCRIBE'),
          onClick: function onClick() {
            if (onSubscribeToLive) {
              onSubscribeToLive(live);
            }
          },
          disabled: isSubscribed || subscriptionIsLoading,
          isDark: true
        })]
      });
    }
    if (!canGoToLiveDetail) {
      return null;
    }
    return /*#__PURE__*/_jsx("footer", {
      className: "mt-24",
      children: /*#__PURE__*/_jsx(PrimaryButton, _objectSpread({
        className: "px-0",
        label: t(liveState === 'live' ? 'GO_TO_LIVE' : 'SEE_DETAILS'),
        isDark: true,
        full: true
      }, goToLiveDetailButtonProps))
    });
  };
  return /*#__PURE__*/_jsxs(_StyledFutureLiveCardContainer, {
    className: cn('flex relative rounded-5 overflow-hidden cursor-default', className),
    style: style,
    "data-testid": dataTestId,
    "data-cy": dataCy,
    $_css: css,
    children: [/*#__PURE__*/_jsx(LazyImage, {
      className: "w-full h-full",
      imgClassName: "object-cover",
      imgxParams: {
        h: 380,
        dpr: 2,
        crop: 'faces'
      },
      src: coverCard || '',
      placeholder: coverCardPlaceholder,
      alt: title,
      isDark: true
    }), _FutureLiveCardOverla || (_FutureLiveCardOverla = /*#__PURE__*/_jsx(FutureLiveCardOverlay, {
      className: "absolute inset-0"
    })), /*#__PURE__*/_jsxs("div", {
      className: cn('absolute inset-0 flex flex-col items-start text-white p-20 md:p-16 lg:p-20', isPremiumLive ? 'justify-between' : 'justify-end'),
      children: [isPremiumLive && /*#__PURE__*/_jsx(PremiumExclusiveTag, {
        isPremium: me === null || me === void 0 ? void 0 : me.isPremium
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col w-full",
        children: [(liveCategory === null || liveCategory === void 0 ? void 0 : liveCategory.name) && /*#__PURE__*/_jsx("span", {
          className: "mb-8 font-label text-secondary-main",
          children: liveCategory.name
        }), /*#__PURE__*/_jsx(Clamp, {
          as: "h5",
          className: "font-h4-md",
          clamp: 3,
          children: title
        }), liveDate && /*#__PURE__*/_jsxs("div", {
          className: "flex items-center mt-8 text-white font-subtitle4",
          children: [/*#__PURE__*/_jsxs("p", {
            className: "flex items-center mr-8",
            children: [_Calendar || (_Calendar = /*#__PURE__*/_jsx(Calendar, {
              size: 20,
              ignoreColor: true,
              className: "mr-8 fill-current"
            })), liveDate.day]
          }), /*#__PURE__*/_jsxs("p", {
            className: "flex items-center",
            children: [_Clock || (_Clock = /*#__PURE__*/_jsx(Clock, {
              size: 20,
              ignoreColor: true,
              className: "mr-8 fill-current"
            })), liveDate.time]
          })]
        }), renderButtons()]
      })]
    })]
  });
};
export default FutureLiveCard;
var _StyledFutureLiveCardContainer = /*#__PURE__*/_styled(FutureLiveCardContainer).withConfig({
  componentId: "sc-1pjjosc-0"
})(["", ""], function (p) {
  return p.$_css;
});